import axios from './axios';
import { API } from '#/config/api';
import dayjs from 'dayjs';
import { PagenateData } from '#/components/parts/Pagenate';
import { UserItem } from './UserService';

export interface OperationItem {
  user_id: string;
  role: string;
  process: string;
  created_at: dayjs.Dayjs;
}

export interface OperationData {
  page: PagenateData;
  data: OperationItem[];
}

class OperationService {
  private loginedUser: UserItem;

  constructor(loginedUser: UserItem)
  {
    this.loginedUser = loginedUser;
  }

  public async getList(query: { [key: string]: any }): Promise<OperationData> {
    const res = await axios.get(API.OperationListEndpoint, {
      params: query,
      headers: {
        Token: this.loginedUser.token,
      },
    });

    return {
      page: {
        ...res.data.page,
        size: query?.size,
      },
      data: res.data.data.map((data: OperationItem) => this.format(data)),
    };
  }

  private format(data: OperationItem) {
    return {
      ...data,
      created_at: dayjs(data.created_at),
    };
  }
}

export default OperationService;
